// extracted by mini-css-extract-plugin
export default {"footerBg":"J-z","footerTopLinks":"K-z","footerFeedback":"L-z","footerSocial":"M-z","footerLegalLinks":"N-z","footerIconCards":"O-z","footerBotCopy":"P-z"};